module.exports = __webpack_public_path__ + "img/paySuccess-cloud.cdaf4038.png";